import {Component, Input} from '@angular/core';

@Component({
    selector: 'add-card',
    template: `
        <ion-card color="dark" class="ion-no-margin position-relative">
            <ion-card-content class="d-flex ion-align-items-center h-100 w-100 ion-no-padding position-absolute">
                <div class="ion-text-center w-100">
                    <ion-icon [name]="icon" class="giant" color="black"></ion-icon>
                    <ng-content></ng-content>
                </div>
            </ion-card-content>
        </ion-card>
    `,
    styles: [`

    `],
    standalone: false
})
export class AddCardComponent {
    @Input()
    public icon = 'add-outline';
}
